import {base, baseConfig} from "../Services/api";

export function getPresence(siteId, date) {
  let url = `${base}presence/${siteId}`;
  if (date) url += `?date=${date}`;
  return fetch(url, baseConfig);
}

export function setPresence(siteId, obj) {
  const conf = {
    method: 'PUT',
    body: JSON.stringify(obj),
    ...baseConfig
  };
  return fetch(`${base}presence/${siteId}`, conf);
}

export function setPresenceForUser(siteId, userId, obj) {
  const conf = {
    method: 'PUT',
    body: JSON.stringify(obj),
    ...baseConfig
  };
  return fetch(`${base}presence/${siteId}/user/${userId}`, conf);
}

export function setPresenceMultiDay(siteId, daysArray) {
  const conf = {
    method: 'PUT',
    body: JSON.stringify({ days: daysArray }),
    ...baseConfig
  };
  return fetch(`${base}presence/${siteId}/multi`, conf);
}

export function getPresenceWeek(siteId, from, to) {
  return fetch(`${base}presence/${siteId}/history?from=${from}&to=${to}`, baseConfig);
}

export function getPresenceHistory(siteId, from, to) {
  let url = `${base}presence/${siteId}/history`;
  if (from && to) {
    url += `?from=${from}&to=${to}`;
  }
  return fetch(url, baseConfig);
}
